"use client";

import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function TheMileHighStandard() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="the-mile-high-standard" className="relative min-h-[90vh] flex items-center justify-center overflow-hidden bg-background bg-cover bg-[center_25%] !bg-[url(https://milehighcavaliers.com/wp-content/uploads/2026/03/COTW-Denver-Show-Newsletter.jpg)]">
      {}
      <div className="absolute inset-0 z-0">
        {}
        <div className="absolute inset-0 bg-background/30 pointer-events-none" aria-hidden="true" />
      </div>

      {}
      <div ref={ref} className={`relative z-10 flex flex-col items-center text-center px-6 max-w-5xl mx-auto transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
        <h1 className="font-sans text-5xl sm:text-6xl md:text-7xl lg:text-8xl font-bold text-foreground mb-6 leading-tight tracking-tight drop-shadow-sm">WELCOME TO <br />Mile High Cavaliers</h1>
        
        <p className="font-sans text-xl sm:text-2xl md:text-3xl text-secondary mb-12 font-medium tracking-wide drop-shadow-sm">
          Health-Tested, Family Raised, Heart-Centered.
        </p>
        
        <div className="flex flex-col sm:flex-row gap-6 items-center justify-center">
          <Button asChild size="lg" className="rounded-none bg-primary text-primary-foreground hover:bg-primary/90 text-base md:text-lg px-10 py-8 uppercase tracking-widest transition-transform hover:scale-105 shadow-lg">
            <Link to="https://milehighcavaliers.com/the-journey-home/#show-calendar">COME MEET US AT A SHOW!</Link>
          </Button>

          <Button asChild variant="outline" size="lg" className="rounded-none border-primary text-primary hover:bg-primary/10 text-base md:text-lg px-10 py-8 uppercase tracking-widest transition-transform hover:scale-105">
            
          </Button>
        </div>
      </div>
    </section>;
}